export default "__VITE_ASSET__00440377__"